import { Link } from "react-router-dom";
import { ArrowLeft, Lock } from "lucide-react";

import PageLayout from "@/components/PageLayout";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

interface Props {
  projectId: string;
}

/** Shown when a signed-in user opens a project they are not a member of. */
const ProjectAccessDenied = ({ projectId }: Props) => {
  const { user } = useAuth();
  // Only admins can edit a project they don't belong to, so only they get the
  // shortcut to add themselves to the team.
  const isAdmin = user?.role === "Admin";

  return (
    <PageLayout>
      <div className="py-12 text-center space-y-4">
        <Lock className="w-8 h-8 mx-auto text-muted-foreground" />
        <div className="space-y-1">
          <p className="font-semibold text-brand-navy">You are not on this project team</p>
          <p className="text-sm text-muted-foreground">
            {isAdmin
              ? "Add yourself to the project team to view its documents and chat."
              : "Ask the project owner to add you to the team."}
          </p>
        </div>
        <div className="flex justify-center gap-3">
          <Button asChild variant="outline">
            <Link to="/projects">
              <ArrowLeft className="w-4 h-4 mr-2" /> Back to Projects
            </Link>
          </Button>
          {isAdmin && (
            <Button asChild className="bg-brand-teal text-white hover:bg-brand-teal/90">
              <Link to={`/projects/${projectId}/edit`}>Edit project setup</Link>
            </Button>
          )}
        </div>
      </div>
    </PageLayout>
  );
};

export default ProjectAccessDenied;
